// @spec SCF-004
// @spec SCF-008
import { createRouter } from '@tanstack/react-router';

import { NotFound } from '@/components/not-found';
import { RoutePending } from '@/components/route-pending';
import { routeTree } from '@/routeTree.gen';
import type { RouterContext } from '@/types/router';

/**
 * Create router with default context.
 * The actual auth context is injected in main.tsx using Clerk hooks.
 */
export function createAppRouter() {
  return createRouter({
    routeTree,
    defaultPendingComponent: RoutePending,
    defaultNotFoundComponent: NotFound,
    context: {
      auth: {
        isLoaded: false,
        isAuthenticated: false,
        user: null,
        getToken: () => Promise.resolve(null),
      },
    } satisfies RouterContext,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
